// Presigned S3 URLs expire after 1 hour; refetch well before then.
export const PRESIGNED_URL_STALE_TIME = 30 * 60 * 1000

// Poll on an interval so links stay live even on a tab left focused past expiry
// (staleTime alone marks data stale but never refetches a focused tab).
export const PRESIGNED_URL_REFETCH_INTERVAL = 45 * 60 * 1000
